module.exports = __webpack_public_path__ + "static/media/bg.4b360347.jpg";